import {Fab, Popover} from "@mui/material";
import React from "react";
import SearchIcon from '@mui/icons-material/Search';

interface SearchFloatButtonProps {
    children: React.ReactNode
    sx?: React.CSSProperties
}

const SearchFloatButton = ({children, sx}: SearchFloatButtonProps) => {
    const [anchorEl, setAnchorEl] = React.useState<Element>();
    return (
        <>
            <Fab
                color="secondary"
                sx={sx}
                onClick={e => setAnchorEl(e.currentTarget)}>
                <SearchIcon/>
            </Fab>
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(undefined)}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                sx={{transform: "translateY(-10px)"}}
            >
                {children}
            </Popover>
        </>
    );
};

export default SearchFloatButton;